export const sidebar = {
  companyDetails: "Company Details",
  personal: "Personal Details",
  teamMembers: "Team Members",
  servicesRates: "Services & Rates",
  skillsAndRates: "Skills & Rates",
  projects: "Projects",
  tasks: "Tasks",
  documents: "Documents",
  earnings: "Earnings",
  invoices: "Invoices",
  financialDetails: "Financial Details",
  logout: "Logout",
  loggingOut: "Logging out...",
};
